import React, { useEffect, useState } from "react";
import "./TabsAndContent/Tabs.css";

const EmploymentGapsForm = ({
  key,
  data,
  index,
  handleReason,
  hasError,
  gapName,
  gapType,
  sequence
}) => {
  const [activeStep, setActiveStep] = useState(0);

  const {
    label,
    category,
    tenure_from,
    tenure_to,
    earlier,
    earlier_seq,
    later,
    later_seq,
    reason,
    gap_duration,
    emp_from_1,
    emp_to_1,
    emp_from_2,
    emp_to_2,
    gap_reason,
  } = data || {};

  const handleOnChange = (e) => {
    e.preventDefault();
    handleReason(e.target.value, index, gapType);
  };

  const steps = [
    {
      title: "Education to Employment Gap of 3 Years",
      content:
        "There is a significant gap between your last education and employment.",
    },
    {
      title: "Second Step",
      content: "Description for the second step.",
    },
    {
      title: "Third Step",
      content: "Description for the third step.",
    },
  ];

  const responseAr = {
    responseArr: {
      emp: [
        {
          label:
            "Deloitte Touche Tohmatsu India LLP, Mumbai to Tcs E-serve International Limited, Mumbai",
          category: 2,
          tenure_from: "2024-05-01",
          tenure_to: "2024-07-01",
          earlier: "01 May, 2024",
          earlier_seq: "Deloitte Touche Tohmatsu India LLP, Mumbai",
          later: "01 Jul, 2024",
          later_seq: "Tcs E-serve International Limited, Mumbai",
          reason: "",
          gap_duration: "61 days",
          emp_from: "01-04-2024",
          emp_to: "01-05-2024",
          gap_reason: "",
        },
      ],
    },
    GAP_REASONS_TYPE: {
      EDU: 1,
      EMP: 2,
      EDUEMP: 3,
      ADD: 4,
    },
    add_emp_gap: 1,
  };

  // const handleNext = () => {
  //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
  // };

  // const handleBack = () => {
  //     setActiveStep((prevActiveStep) => prevActiveStep - 1);
  // };

  useEffect(() => {
    console.log("gapkey....", gapType);
  });

  return (
    <>
      <div
        className=""
        style={{
          backgroundColor: "white",
          padding: 10,
          border: "1px solid white",
          marginBottom: "20px"
        }}
      >
        <div className="initialDetails">
          <h1
            className="tabsContentHead pt-3"
            style={{ fontSize: "16px", lineHeight: "24px" }}
          >
            {gapType === "eduemp" ? `${sequence}. Education to Employment Gap of (${gap_duration})` : `${sequence}. Employment Gap of (${gap_duration})`}
          </h1>
          <p className="tabsContentSubHead" style={{fontSize : "14px", lineHeight: "20px"}}>
            {
              gapType === "eduemp" ? "There is a significant gap between your last education and employment" : "There is a significant gap between two employments"
            }
            
          </p>
        </div>
        <div className="row m-0 p-0">
          <div className="col-lg-4 col-md-6 col-sm-12 ml-3">
            <div className="verticalStepper">
              <div key={index} className={`step`}>
                <div className="stepNumber"></div>
                <div className="stepLine"></div>
                <div className="stepContent">
                  <h2 className="stepTitle" style={{fontSize : "14px", lineHeight: "20px", color: "#1D2939"}}>{`${emp_from_1} - ${emp_to_1}`}</h2>
                  <p className="stepDescription" style={{fontSize : "14px", lineHeight: "20px", fontWeight: "500", color: "#101828"}}>{earlier_seq}</p>
                </div>
              </div>
              <div key={index} className={`step active`}>
                <div className="stepNumber"></div>
                <div className="stepLine"></div>
                <div className="stepContent">
                  <h2 className="stepTitle" style={{fontSize : "14px", lineHeight: "20px"}}>{`${tenure_from} - ${tenure_to} ( ${gap_duration})`}</h2>
                  {/* <p className="stepDescription">{step.content}</p> */}
                </div>
              </div>
              <div key={index} className={`step`}>
                <div className="stepNumber"></div>
                {/* {index < steps.length - 1 && <div className="stepLine"></div>} */}
                <div className="stepContent">
                  <h2 className="stepTitle" style={{fontSize : "14px", lineHeight: "20px", color: "#1D2939"}}>{`${emp_from_2} - ${emp_to_2}`}</h2>
                  <p className="stepDescription" style={{fontSize : "14px", lineHeight: "20px", fontWeight: "500", color: "#101828"}}>{later_seq}</p>
                </div>
              </div>
            </div>
            {/* <div className="stepButtons">
                            <button disabled={activeStep === 0} onClick={handleBack}>
                                Back
                            </button>
                            <button disabled={activeStep === steps.length - 1} onClick={handleNext}>
                                Next
                            </button>
                        </div> */}
          </div>
          <div className="col-lg-7 col-md-5 col-sm-11 rounded " style={{alignContent:"center"}}>
            <div className="floating-label">
            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              style={{ height: "200px", resize: "none" , marginTop:"auto", marginBottom:"auto"}}
              // placeholder="Enter Reason"
              value={gap_reason}
              onChange={(e) => handleOnChange(e)}
            ></textarea>
                             <label htmlFor={"exampleFormControlTextarea1"} className={gap_reason && "focused"}>
              {'Reason'}
              {<sup className="text-danger">*</sup>}
            </label>
            </div>
            {hasError == true ? (
              gap_reason == "" || gap_reason == null ? (
                <p className="err text-danger">This field is required</p>
              ) : (
                <p className="err text-danger">Please provide valid input</p>
              )
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EmploymentGapsForm;
